import React, { useState, useImperativeHandle, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types';
import Button from '../Button'
import './style.scss'
import Alert from '../Alert'

const CustomModal = ({
    id,
    headerText,
    children,
    onClose,
    isValid = true,
    onReset
}, ref) => {
    const [isOpen, setIsOpen] = useState(true)
    const { t } = useTranslation()

    useImperativeHandle(ref, () => ({
        canClose: () => isValid
    }));

    const handleClose = (e) => {
        e.stopPropagation()

        if (isValid && ref.current && ref.current.canClose()) {
            onClose()
        }
    }

    return (
        <div
            className={`trip-modal trip-modal--${id} ${isOpen ? "trip-modal--show" : ""} animation-transform box-shadow`}
            tabIndex="-1"
            role="dialog"
        >
            <div className="trip-modal__header">
                <h3 className="trip-modal__title">{headerText}</h3>
                <Button
                    clickHandler={handleClose}
                    label="&times;"
                    variant="none"
                    extraCss="trip-btn--close"
                />
            </div>
            <div className="trip-modal__content">
                {children}
                {!isValid && <Alert message={t('common.valid_error')} variant="danger" align="left" />}
            </div>
            <div className="trip-modal__footer">
                <Button
                    clickHandler={onReset}
                    label={t("common.btn_reset")}
                    variant="secondary"
                    extraCss="trip-btn--reset"
                />
                <Button
                    clickHandler={handleClose}
                    label={t("common.btn_save")}
                    variant="primary"
                    extraCss="trip-btn--save"
                />
            </div>
        </div>
    )
}

export default forwardRef(CustomModal)

CustomModal.propTypes = {
    id: PropTypes.string.isRequired,
    headerText: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
    onReset: PropTypes.func
}
